import type { ComponentProps } from 'react';

import { cn } from '@repo/lib/cn';

import { Skeleton } from '@/components/ui/skeleton';

export default function NotificationCardSkeleton(notificationCardSkeletonProps: ComponentProps<'div'>) {
  const { className, ...props } = notificationCardSkeletonProps;
  return (
    <div className={cn('bg-background relative space-y-3 rounded-md border p-2 transition-all', className)} {...props}>
      <div className="flex flex-col gap-2">
        <Skeleton className={'h-4 w-13 rounded-sm'} />
        <Skeleton className={'h-4 w-1/2 rounded-sm'} />
      </div>
      <div className="flex flex-col gap-2">
        <Skeleton className={'h-3 w-full rounded-sm'} />
        <Skeleton className={'h-3 w-2/3 rounded-sm'} />
      </div>
      <div className="flex justify-between">
        <Skeleton className={'h-4 w-12 rounded-sm'} />
        <Skeleton className={'h-4 w-13 rounded-sm'} />
      </div>
    </div>
  );
}
